import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Icon from 'components/DesignSystem/Icon';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import { Chart } from 'helper/products/synopticCharts';
import { selectChart, setChart } from 'redux/reducers/synopticChartsReducer';
import useGetOptions from 'utils/hooks/synopticCharts/useGetOptions';
import { cssVar } from 'constants/theme';

export interface CampoSectionProps {
  onSelect?: () => void;
}

export default function CampoSection({ onSelect }: CampoSectionProps) {
  const dispatch = useDispatch();
  const { monitoringOptions } = useGetOptions();
  const chart: Chart | undefined = useSelector(selectChart);
  const [openGroup, setOpenGroup] = useState('');

  if (!monitoringOptions || monitoringOptions.length === 0) {
    return <p className="sc-mobile-panel-hint">Carregando campos...</p>;
  }

  return (
    <>
      {monitoringOptions.map((group) => {
        const isOpen = openGroup === group.label;
        const hasSelection = group.charts.some((option) => option.id === chart?.id);

        return (
          <div key={group.label} className="sc-mobile-panel-group">
            <button
              type="button"
              className="sc-mobile-panel-group-header"
              aria-expanded={isOpen}
              onClick={() => setOpenGroup((current) => (current === group.label ? '' : group.label))}
            >
              <span className="sc-mobile-panel-group-meta">
                <span className="sc-mobile-panel-group-title">{group.label}</span>
                <span className="sc-mobile-panel-group-count">
                  {group.charts.length}
                  {' '}
                  {group.charts.length === 1 ? 'campo' : 'campos'}
                </span>
              </span>
              <span className="sc-mobile-panel-group-indicator">
                {hasSelection && !isOpen && <span className="sc-mobile-panel-group-dot" />}
                <Icon
                  iconType={isOpen ? 'down_arrow' : 'right_arrow'}
                  color={cssVar(isOpen ? 'text-accent' : 'text-muted')}
                  className="sc-mobile-panel-group-chevron"
                />
              </span>
            </button>
            {isOpen && (
              <div className="sc-mobile-panel-group-body">
                {group.charts.map((option) => (
                  <OptionRow
                    key={option.id}
                    label={option.campo}
                    selected={chart?.id === option.id}
                    onSelect={() => {
                      dispatch(setChart(option));
                      onSelect?.();
                    }}
                  />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
